import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'

export const GET_POWER_BI_LIST = async ({ user_id, token }) => {
  try {
    return await clientPublic
      .get(`powerbi/report/${user_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const GET_POWER_BI_BY_ID = async ({ user_id, token, id }) => {
  try {
    return await clientPublic
      .get(`powerbi/report/${user_id}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
